import { useProcessMembershipChargePayment } from 'api/Memberships'
import { Notification, useNotificationContext } from 'ui/components/Notification'
import { formatMoney } from 'ui/components/Money'
import { DateTime } from 'luxon'
import { Text } from 'ui/components/Text'
import { ConfirmationModal } from 'ui/Modal'

export const ProcessMembershipChargeModal = ({ isOpen, onClose, charge }) => {
  const { isLoading, mutate } = useProcessMembershipChargePayment()
  const notification = useNotificationContext()
  const handleProcess = () => {
    mutate([charge.membership.id, charge.id], {
      onSuccess: () => {
        onClose()
        notification.notify(
          <Notification
            title="Membership charge processed successfully"
            description={`The membership has been processed successfully.`}
            variant="success"
            autoDismiss
          />
        )
      },
      onError: (response) => {
        notification.notifyApiError(response)
        onClose()
      },
    })
  }

  return (
    <ConfirmationModal
      isOpen={isOpen}
      title="Process membership charge"
      onClose={onClose}
      onConfirm={handleProcess}
      confirming={isLoading}
      confirmButtonLabel="Process Charge"
      variant="info"
    >
      {charge !== null && (
        <>
          <Text type="caption">
            You are about to process a charge for the period{' '}
            {DateTime.fromJSDate(charge?.billing_period_from).toLocaleString(DateTime.DATE_MED)} to{' '}
            {DateTime.fromJSDate(charge?.billing_period_to).toLocaleString(DateTime.DATE_MED)}
          </Text>
          <Text type="caption" className="mt-2">
            Are you sure you want to process this membership charge of{' '}
            {formatMoney({ amount: charge?.amount, currency: charge?.currency })}?
          </Text>
        </>
      )}
    </ConfirmationModal>
  )
}
